/**
 * Settings plugin get all settings from plataform
 * @type {{install(*, *): void}}
 */
const SettingsPlugin = {
    install(app, options) {
        app.config.globalProperties.$getSettings = false;

        app.config.globalProperties.$createSettings = (clientSettings, settings = {}) => {
            app.config.globalProperties.$getSettings = {
                clientSettings,
                settings
            };
        };
    }
};

export default SettingsPlugin;
